<template>
    <v-container fluid>
        <!-- <v-row>
            <v-col cols="4" class="text-right text-h5 font-weight-bold">{{ title }}</v-col>
            <v-col cols="8">&nbsp;</v-col>

            <v-col cols="4" class="text-right">{{ description }}</v-col>
            <v-col cols="8">
                <slot></slot>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col cols="4" class="text-right d-flex flex-column">
                <span class="text-h5 font-weight-bold">{{ title }}</span>
                <span>{{ description }}</span>
            </v-col>
            <v-col cols="8">
                <slot></slot>
            </v-col>
        </v-row>
    </v-container>
</template>

<style lang="scss" scoped>
</style>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {

    @Prop({ default: "Sin título" })
    title?: string;

    @Prop({ default: "Descripción" })
    description?: string;

}
</script>
